<template>
  <div
    id="video-component"
    ref="videoPlay"
  >
    <!--视频组件部分-->
    <div
      v-if="isAutoload"
      id="video-box"
    >
      <div class="video-content">
        <!--资源不存等错误信息-->
        <div
          v-show="prompt"
          class="message-cover"
        >
          <div class="message-error">
            <div class="message">
              <p class="m-title">
                {{ $t('Emm...视频加载失败') }}
              </p>
              <div class="m-content">
                <p>{{ $t('我们也不希望看到这种情况，请您检查:') }}</p>
                <p>{{ `1.${$t('网络链接是否正常')}` }}</p>
                <p>{{ `2.${$t('视频文件是否损坏')}` }}</p>
              </div>
            </div>
            <button
              class="operation"
              @click="reGetVideoResource"
            >
              {{ $t('重试') }}
            </button>
          </div>
        </div>

        <!-- 资源加载提示信息 -->
        <div
          v-show="showLoading"
          class="message-cover"
        >
          <div class="loading" />
        </div>

        <!-- 资源转码 -->
        <div
          v-show="transcoding"
          class="message-cover"
        >
          <img
            src="./image/color-bounce-black.gif"
            class="transcoding"
          >
          <div class="message-trans">
            {{ $t('视频转码中，请耐心等待') }}
          </div>
        </div>

        <!-- 视频转码提示信息 -->
        <div
          v-show="transError"
          class="message-cover"
        >
          <div class="message-warn">
            <div class="message">
              {{ $t('视频正在转码，暂时无法播放，请稍后重试') }}
            </div>
            <button
              class="operation"
              @click="reGetVideoResource"
            >
              {{ $t('重试') }}
            </button>
          </div>
        </div>

        <!--视频组件-->
        <videoContent
          v-if="hasResource"
          :video-options="videoOptions"
          :language="language"
        />
      </div>
    </div>
  </div>
</template>

<script>
import * as Util from 'js/util/util'

const { jsonp, getData } = require('js/api/getdata').default

const videoContent = () => import('components/common/video/index.vue')

export default {
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
    language: {
      type: String,
      default: Util.getLanguage(),
    },
    autoLoad: {
      type: Boolean,
      default: true,
    },
    previewHandler: {
      type: Object,
      default: null,
    },
  },
  components: {
    videoContent,
  },
  data() {
    return {
      isAutoload: true, // 是否为自动加载
      isVideo: true, // 是否为视频
      showLoading: true, // 资源加载中
      transcoding: false, // 是否需要编译
      transError: false, // 5次请求解析异常，显示重试信息
      hasResource: false, // 资源是否存在
      prompt: false, // 提示信息（资源不存在，异常等错误...）
      videoOptions: { // 视频资源加载配置
        autoplay: true, // 自动播放
        controls: true, // 播放控件
        techOrder: ['html5'], // 播放方式
        // poster: 'xxx',         // 视频封面图地址
        muted: false, // 是否静音
        // aspectRatio: "16:9",   //尺寸
        inactivityTimeout: 0,
        fluid: false, // 流体(自适应)
        preload: 'metadata', // 建议浏览器是否在加载<video>元素时开始下载视频数据。(预加载)
        // auto:立即加载视频（如果浏览器支持它）。一些移动设备将不会预加载视频，以保护用户的带宽/数据使用率。这就是为什么这个值被称为“自动”，而不是更确凿的东西
        // metadata:只加载视频的元数据，其中包括视频的持续时间和尺寸等信息。有时，元数据会通过下载几帧视频来加载。
        controlBar: { // 设置控制条组件 /* 设置控制条里面组件的相关属性及显示与否*/
          currentTimeDisplay: true,
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: true,
          volumePanel: {
            inline: false,
          },
        },
        /* 使用children的形式可以控制每一个控件的位置，以及显示与否
                        children: [
                            {name: 'playToggle'}, // 播放按钮
                            {name: 'currentTimeDisplay'}, // 当前已播放时间
                            {name: 'progressControl'}, // 播放进度条
                            {name: 'durationDisplay'}, // 总时间
                            { // 倍数播放
                                name: 'playbackRateMenuButton',
                                'playbackRates': [0.5, 1, 1.5, 2, 2.5]
                            },
                            {
                                name: 'volumePanel', // 音量控制
                                inline: false, // 不使用水平方式
                            },
                            {name: 'FullscreenToggle'} // 全屏
                        ]
                    }, */
        sources: [
          {
            src: '',
            type: 'video/mp4',
          },
        ],
      },
      reqTime: '', // 转码请求时间
      reqInterval: '', // 转码回调
    }
  },
  computed: {
    isFooterHide() {
      return this.$store.state.isFooterHide
    },
  },
  watch: {
    isFooterHide() {
      this.setPosition()
    },
  },
  mounted() {
    // 检测是否支持html5
    this.checkVideo()
    // 将是否自动加载赋值给内部元素
    this.isAutoload = this.autoLoad
    this.setPosition()
    window.addEventListener('resize', this.setPosition)
  },
  destroyed() {
    window.removeEventListener('resize', this.setPosition)
  },
  methods: {
    previewDone(data) {
      this.videoOptions.sources['0'].src = data.stat_url
      this.hasResource = true
      this.showLoading = false
      this.transcoding = false
      this.transError = false
      this.prompt = false
    },
    previewFail() {
      this.isVideo = false
      this.showLoading = false
      this.transcoding = false
      this.transError = false
      this.prompt = true
    },
    progressCallback(progressData) {
      if (progressData.result === 'converting') { // 视频的转码轮询过程
        // 显示转码
        this.transcoding = true
        this.showLoading = false
        this.transError = false
        this.prompt = false
        if (this.reqTime === '') {
          this.reqTime = Date.parse(new Date())
        } else if (Date.parse(new Date()) - this.reqTime >= 6000) {
          this.previewHandler.stopProgress() // 停止循环查询
          this.$nextTick(() => {
            this.reqTime = ''
            this.reqInterval = ''
            this.hasResource = false
            this.showLoading = false
            this.transError = true
            this.transcoding = false
            this.prompt = false
          })
        }
      }
    },
    reGetVideoResource() {
      this.transError = false
      this.showLoading = true
      this.$emit('reGetData')
    },
    /**
             * html5视频检测
             */
    checkVideo() {
      if (document.createElement('video').canPlayType) {
        const vidTest = document.createElement('video')
        const h264Test = vidTest.canPlayType('video/mp4; codecs="avc1.42E01E, mp4a.40.2"')
        if (!h264Test) {
          console.log('sorry mp4')
        } else {
          console.log('mp4 yes')
        }
      } else {
        console.log('Sorry. No video support.')
      }
    },
    // 这个方法废弃,现在走preview-sdk.js中的流程
    startPreview(meteData) {
      return false
    },
    /**
             * 根据data数据解析相应的播放视频资源
             */
    getVideoResource() {
      // 隐藏提示框(重试)
      this.transError = false
      // 销毁异常提示
      this.prompt = false

      // 判断data资源是否正确，//判断是否为视频资源
      if (Object.keys(this.data).length <= 0 || this.data.mime_type.indexOf('video') == -1) {
        this.isVideo = false
        this.showLoading = false
        this.transcoding = false
        this.transError = false
        this.prompt = true
      }
      const params = {
        neid: this.data.neid,
        hash: this.data.hash,
        rev: this.data.rev,
        delivery_code: this.data.delivery_code,
        account_id: -1,
        uid: -1,
      }
      getData('deliveryAvStat', params).then((res) => {
        if (res.data.state === 200) {
          this.videoOptions.sources['0'].src = `${this.data.preview_url}&token=${this.data.token}`
          this.hasResource = true
          this.showLoading = false
          this.transcoding = false
          this.transError = false
          this.prompt = false
        }
      })
      // // 组合请求参数
      // const params = {
      //   path: this.data.path,
      //   path_type: this.data.path_type,
      //   from: this.data.from || '',
      //   neid: this.data.neid,
      //   prifix_neid: this.data.prifix_neid || '',
      //   rev: this.data.rev || '',
      //   type: this.data.type || 'av',
      //   root: this.data.root || 'ent',
      //   _: Date.parse(new Date()),
      // }
      //
      // // 转化path
      // const encodePath = encodeURIComponent(params.path)
      // // 设置共有url部分
      // const baseUrl = `path=${encodePath
      // }&path_type=${params.path_type}&from=${params.from}&neid=${params.neid
      // }&prifix_neid=${params.prifix_neid}&rev=${params.rev}&type=${params.type
      // }&root=${params.root}&hash=${this.data.hash}`
      //
      // // 请求数据
      // jsonp(`/v2/video_stat?${baseUrl}`, 'callback', (res) => {
      //   if (res.data && res.data.code == 200) {
      //     // 组合请求url
      //     const src = Util.encodePath(`/v2/preview_router?${baseUrl}&_=${params._}&interface_version=2020`)
      //     // 校验资源
      //     getData(`${src}&probe=1`).then(() => {
      //       // 返回请求地址
      //       this.videoOptions.sources['0'].src = src
      //       this.hasResource = true
      //       this.showLoading = false
      //       this.transcoding = false
      //       this.transError = false
      //       this.prompt = false
      //     }).catch((err) => {
      //       if (err.response && err.response.status === 403) {
      //         // 关闭循环
      //         clearInterval(this.reqInterval)
      //         this.reqTime = ''
      //         this.reqInterval = ''
      //         // 提示
      //         this.showLoading = false
      //         this.transcoding = false
      //         this.transError = false
      //         this.prompt = true
      //       }
      //     })
      //   } else {
      //     if (res.data.code == 'transcoding') { // 视频的转码轮询过程
      //       // 显示转码
      //       this.transcoding = true
      //       this.showLoading = false
      //       this.transError = false
      //       this.prompt = false
      //
      //       // 记录请求的当前时间
      //       if (this.reqTime == '') {
      //         this.reqTime = Date.parse(new Date())
      //       }
      //       if (this.reqInterval == '') {
      //         this.reqInterval = setInterval(() => {
      //           if (Date.parse(new Date()) - this.reqTime < 30000) {
      //             if (this.videoOptions.sources['0'].src != '') {
      //               clearInterval(this.reqInterval)
      //               this.reqTime = ''
      //               this.reqInterval = ''
      //               return
      //             }
      //             this.getVideoResource() // 30s 请求数据
      //           } else {
      //             clearInterval(this.reqInterval)
      //             this.reqTime = ''
      //             this.reqInterval = ''
      //             // 提示数据
      //             this.hasResource = false
      //             this.showLoading = false
      //             this.transError = true
      //             this.transcoding = false
      //             this.prompt = false
      //           }
      //         }, 6000)
      //       }
      //       return
      //     }
      //     // console.log(res.data.message);
      //     clearInterval(this.reqInterval)
      //     this.reqTime = ''
      //     this.reqInterval = ''
      //
      //     // 返回提示信息
      //     this.hasResource = false
      //     this.showLoading = false
      //     this.transError = false
      //     this.transcoding = false
      //     this.prompt = true
      //   }
      // })
    },
    /**
             * 设置显示位置
             */
    setPosition() {
      const me = this
      setTimeout(() => {
        // 外部组件的宽高
        const parVideobox = document.getElementById('video-component')
        // 视频宽高
        const videobox = document.getElementById('video-box')
        if (videobox && parVideobox) {
          // 获取视频加载区域的可是宽高
          const baseHeight = parVideobox.offsetHeight
          const winHeight = me.isFooterHide ? baseHeight - 144 : baseHeight
          const winWidth = parVideobox.clientWidth
          console.log(winWidth, winHeight, '--width---height--')
          // 设置宽高比率 宽/高
          const ratio = 9 / 16
          // 屏幕可视区域在大于1620和836上显示
          if (winWidth >= 1620) {
            videobox.style.width = '1280px'
            videobox.style.height = '720px'
            if (winHeight >= 786) {
              videobox.style.height = '720px'
            } else {
              // 重新调整高度
              const numHeight = videobox.style.height.replace(/px/, '')
              if (numHeight > winHeight) {
                videobox.style.height = `${winHeight * 0.95}px`
                videobox.style.width = `${(winHeight * 0.95) / ratio}px`
              } else {
                videobox.style.width = '1168px'
                videobox.style.height = '667px'
              }
            }
          } else {
            // 1024和1620之间
            if (winWidth >= 1024 && winWidth < 1620) {
              videobox.style.width = `${winWidth * 0.79}px`
              videobox.style.height = `${(winWidth * 0.79) * ratio}px`
            }

            // 小于1024
            if (winWidth < 1024) {
              videobox.style.width = `${winWidth * 0.84}px`
              videobox.style.height = `${(winWidth * 0.84) * ratio}px`
            }

            // 重新调整高度
            const numHeight = videobox.style.height.replace(/px/, '')
            if (numHeight > winHeight) {
              videobox.style.height = `${winHeight * 0.95}px`
              videobox.style.width = `${(winHeight * 0.95) / ratio}px`
            }
          }

          // 高度小于到490px不会缩放
          if (winHeight < 490) {
            videobox.style.width = '610px'
            videobox.style.height = '350px'
          }

          // 设置居中,这俩计算不是同一个值，不要看着都是替换px就合并掉
          const newHeight = videobox.style.height.replace(/px/, '')
          videobox.style.marginTop = `${(winHeight - newHeight) * 0.5}px`
        }
      }, 100)
    },
  },
}
</script>

<style lang="less" scoped>
/**视频组件 */
#video-component {
  height:100%;
  width:100%;
  background-color:#f1f1f1;
  display: flex;
  #video-box {
    box-sizing: border-box;
    position: relative;
    margin: auto;
    border: 20px solid #e8ebef;
    background-color:#1f1f1f
  }

  .video-content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }

  /**黑色遮罩区域 */
  .message-cover {
    background-color: #1f1f1f;
    box-sizing: border-box;
    color: #fff;
    display: block;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    height: 100%;
    position: absolute;
    width: 100%;
    z-index: 0;
  }

  /**视频转码过程 */
  .message-trans{
    color: #FFFFFF;
    text-align: center;
    width: 100%;
    position: absolute;
    top: 52%;
    margin: 0px;
    padding-top: 32px;
  }

  /**视频转码警告 */
  .message-warn {
    text-align: center;
    width: 100%;
    position: absolute;
    top: 46%;
    margin: 0px;
    font-size: 14px;
    color: #FFFFFF;
    letter-spacing: 0;
    .message{
      margin-bottom:20px;
    }
    .operation{
      outline: none;
      width:80px;
      height:32px;
      font-size: 14px;
      color: #FFFFFF;
      background: #1f1f1f;
      border: 1px solid #FFFFFF;
      border-radius: 2px;
      cursor: pointer;
    }
  }

  /**视频异常提示 */
  .message-error {
    text-align: center;
    width: 100%;
    position: absolute;
    top: 35%;
    margin: 0px;
    font-size: 14px;
    color: #FFFFFF;
    letter-spacing: 0;

    .message{
      margin-bottom:20px;
      .m-title{
        margin-bottom:8px;
      }
      .m-content{
        margin-bottom:20px;
      }
    }

    .operation{
      outline: none;
      width:80px;
      height:32px;
      font-size: 14px;
      color: #FFFFFF;
      background: #1f1f1f;
      border: 1px solid #FFFFFF;
      border-radius: 2px;
      cursor: pointer;
    }
  }

  /**视频资源加载前的loading */
  .loading{
    width: 60px;
    height: 60px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin: -30px 0 0 -30px;
    z-index: 0;
    background: url(./image/search-load.gif) no-repeat;
    background-size:60px 60px;
  }

  /**视频转码过程中的loading */
  .transcoding{
    width: 50px;
    height: 50px;
    top: 50%;
    left: 50%;
    margin-top: -25px;
    margin-left: -25px;
    position: absolute;
    z-index: 0;
  }
}

</style>
